import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logoDark from "../assets/images/logo-amcatd-dark.png";
import logoWhite from "../assets/images/logo-amcatd-white.png";

import { FiDribbble, FiLinkedin, FiGithub } from "../assets/icons/vander";

export default function Navbar() {
  const { t } = useTranslation();
  const [isOpen, setMenu] = useState(true);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    activateMenu();
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  const getClosest = (elem, selector) => {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem;
    }
    return null;
  };

  const activateMenu = () => {
    var menuItems = document.getElementsByClassName("sub-menu-item");
    if (menuItems) {
      var matchingMenuItem = null;
      for (var idx = 0; idx < menuItems.length; idx++) {
        if (menuItems[idx].href === window.location.href) {
          matchingMenuItem = menuItems[idx];
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");

        var immediateParent = getClosest(matchingMenuItem, "li");

        if (immediateParent) {
          immediateParent.classList.add("active");
        }

        var parent = getClosest(immediateParent, ".child-menu-item");
        if (parent) {
          parent.classList.add("active");
        }

        var parent = getClosest(parent || immediateParent, ".parent-menu-item");

        if (parent) {
          parent.classList.add("active");

          var parentMenuitem = parent.querySelector(".menu-item");
          if (parentMenuitem) {
            parentMenuitem.classList.add("active");
          }

          var parentOfParent = getClosest(parent, ".parent-parent-menu-item");
          if (parentOfParent) {
            parentOfParent.classList.add("active");
          }
        } else {
          var parentOfParent = getClosest(
            matchingMenuItem,
            ".parent-parent-menu-item"
          );
          if (parentOfParent) {
            parentOfParent.classList.add("active");
          }
        }
      }
    }
  };
  const toggleMenu = () => {
    setMenu(!isOpen);
    if (document.getElementById("navigation")) {
      const anchorArray = Array.from(
        document.getElementById("navigation").getElementsByTagName("a")
      );
      anchorArray.forEach((element) => {
        element.addEventListener("click", (elem) => {
          const target = elem.target.getAttribute("href");
          if (target !== "") {
            if (elem.target.nextElementSibling) {
              var submenu = elem.target.nextElementSibling.nextElementSibling;
              submenu.classList.toggle("open");
            }
          }
        });
      });
    }
  };
  return (
    <>
      <nav
        id="topnav"
        className={`${scroll ? "nav-sticky" : ""} defaultscroll is-sticky`}
      >
        <div className="container relative" style={{ display: "flex" }}>
          <Link className="logo" to="/">
            <img
              src={logoDark}
              className="h-5 inline-block dark:hidden"
              alt=""
            />
            <img
              src={logoWhite}
              className="h-5 hidden dark:inline-block"
              alt=""
            />
          </Link>
          <div className="menu-extras">
            <div className="menu-item">
              <Link
                to=""
                className="navbar-toggle"
                id="isToggle"
                onClick={toggleMenu}
              >
                <div className="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </Link>
            </div>
          </div>
          <div
            id="navigation"
            className={`${isOpen === true ? "hidden" : "block"}`}
            style={{ marginLeft: "75px" }}
          >
            <ul className="navigation-menu justify-end">
              <li className="has-submenu parent-menu-item">
                <Link to="/home">{t("menu.home")}</Link>
              </li>

              <li className="has-submenu parent-parent-menu-item">
                <Link to="#">{t("menu.about_us")}</Link>
                <span className="menu-arrow"></span>
                <ul className="submenu">
                  <li>
                    <Link to="/aboutus" className="sub-menu-item">
                      {t("menu.about_us")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/project" className="sub-menu-item">
                      {t("menu.projects_partners")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/property" className="sub-menu-item">
                      {t("menu.property")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/collaborator" className="sub-menu-item">
                      {t("menu.collaborator")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/accountability" className="sub-menu-item">
                      {t("menu.accountability")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="has-submenu parent-parent-menu-item">
                <Link to="#">{t("menu.informative")}</Link>
                <span className="menu-arrow"></span>
                <ul className="submenu">
                  <li>
                    <Link to="/news" className="sub-menu-item">
                      {t("menu.news")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/journal" className="sub-menu-item">
                      {t("menu.amcatd_journal")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="has-submenu parent-menu-item">
                <Link to="#">{t("menu.events")}</Link>
                <span className="menu-arrow"></span>
                <ul className="submenu">
                  <li>
                    <Link to="/event" className="sub-menu-item">
                      {t("menu.photos_events")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/space" className="sub-menu-item">
                      {t("menu.space_reservations")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="has-submenu parent-menu-item">
                <Link to="#">Serviços</Link>
                <span className="menu-arrow"></span>
                <ul className="submenu">
                  <li>
                    <Link to="/blogs" className="sub-menu-item">
                      {t("menu.workforce")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/blogs" className="sub-menu-item">
                      {t("menu.stores")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/contact" className="sub-menu-item">
                  {t("menu.contact")}
                </Link>
              </li>

              <li>
                <Link to="/login" className="sub-menu-item">
                  {t("menu.login")}
                </Link>
              </li>
            </ul>
          </div>
          <ul className="buy-button list-none mb-0 space-x-1">
            <li className="inline mb-0">
              <Link
                to=""
                className="h-8 w-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-[15px] text-center rounded-xl bg-orange-500 hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white"
              >
                <FiDribbble className="h-[14px] w-[14px] align-middle" />
              </Link>
            </li>
            <li className="inline mb-0">
              <Link
                to=""
                className="h-8 w-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-[15px] text-center rounded-xl bg-orange-500 hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white"
              >
                <FiLinkedin className="h-[14px] w-[14px] align-middle" />
              </Link>
            </li>
            <li className="inline mb-0">
              <Link
                to=""
                className="h-8 w-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-[15px] text-center rounded-xl bg-orange-500 hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white"
              >
                <FiGithub className="h-[14px] w-[14px] align-middle" />
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}
